export default class TaskCell {
    
}